import { render, staticRenderFns } from "./LayoutLanding.vue?vue&type=template&id=555759b2&"
import script from "./LayoutLanding.vue?vue&type=script&lang=js&"
export * from "./LayoutLanding.vue?vue&type=script&lang=js&"
import style0 from "./LayoutLanding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports